<ea-dropdown
	[showArrow]="false"
	[orientation]="DROPDOWN_ORIENTATION.Right"
	[dropdownType]="DROPDOWN_TYPES.Input"
	[dropdownId]="dropdownId">
	<ea-dropdown-button>
		@if (hasSelectedTypeValue) {
			<div>
				<button
					id="dropdown-icon-button"
					class="form-control dropdown-icon-button"
					aria-controls="dropdown-icon-menu"
					type="button"
					aria-labelledby="dropdown-icon-label dropdown-icon-button"
					aria-haspopup="listbox"
					(focusout)="closeDropdown($event)"
				>
					<i class="fa {{ selectedNotificationFilterIcon }}"></i>
					{{ selectedTypeValue }}
				</button>
			</div>
		}
	</ea-dropdown-button>
	<ng-template #dropdownContent>
		<div class="task-list-action-menu" data-cy="task-list-action-menu">
			<div data-cy="task-list-action-button">
				<div>
					<ul id="dropdown-icon-menu" class="dropdown-icon-menu" role="listbox">
						@for (option of notificationTypeOptions; track option; let i = $index) {
							<div>
								<li
									id="dropdown-icon-option-{{ i }}"
									class="dropdown-icon-option"
									role="option"
									(keydown)="handleKeydown($event, option.value, i)"
									(focusout)="closeDropdown($event)"
									tabindex="0"
								>
									<i class="fa {{ option.icon }}" aria-hidden="true"></i>
									<button
										class="dropdown-icon-option"
										id="{{ option.display }}DropdownOption"
										tabindex="-1"
										(click)="dropdownValueChange(option.value, i)"
									>
										{{ option.display }}
									</button>
								</li>
							</div>
						}
					</ul>
				</div>
			</div>
		</div>
	</ng-template>
</ea-dropdown>
